import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { Radio as Radio$1 } from 'react-aria-components';

const radio = "_radio_678cl_1";
const styles = {
	radio: radio
};

const Radio = (_a) => {
  var { children, className } = _a, props = __rest(_a, ["children", "className"]);
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    React.createElement(Radio$1, Object.assign({ className: clsx(className, styles.radio), "data-zds": true }, props), children)
  );
};

export { Radio };
//# sourceMappingURL=Radio.es.js.map
